import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 25.482px;
  height: 20.704px;
  margin-right: 0.5rem;
`;

const OSOtherIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.89 0H1.593A1.593 1.593 0 0 0 0 1.593v17.519A1.593 1.593 0 0 0 1.593 20.7h22.3a1.593 1.593 0 0 0 1.593-1.593V1.593A1.593 1.593 0 0 0 23.89 0zM3.822 8.608v-2.1l7.963 3.655v1.656l-7.963 3.654v-2.11l5.184-2.389zm13.219 7.637h-5.1v-1.911h5.1zM1.593 3.345V1.593h22.3v1.752z"
        fill="#3d434e"
      />
    </Svg>
  );
};

export default OSOtherIcon;
